export default "__VITE_ASSET__beb40272__"